import React from 'react';
import classes from "./FaqTitle.module.css";

export default function FaqTitle() {
    return (
        <div className={classes.faq_title}>
            <h2>FAQ</h2>
            <div className={classes.first_frame}>
                <svg width="238" height="163" viewBox="0 0 238 163" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 40C79.6355 24.7533 157.635 12.0867 236 2" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M40 75.0397C95.3929 67.0614 151.307 63.2574 207.27 63.6597" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17.95 121.28C66.7612 130.445 114.746 143.565 161.43 160.51" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <div className={classes.second_frame}>
                <svg width="80" height="60" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.8671 12.2157L14.7955 57.6116" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.5603 23.5361L40.4613 48.9582" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M68.389 1.6854L61.4092 32.0509" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M47.8394 12.9102L75.6386 26.7744" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </div>
    )
}
